import { render, staticRenderFns } from "./edit-admins.component.html?vue&type=template&id=5ce9b6c4&scoped=true&"
import script from "./edit-admins.component.ts?vue&type=script&lang=ts&"
export * from "./edit-admins.component.ts?vue&type=script&lang=ts&"
import style0 from "./edit-admins.component.scss?vue&type=style&index=0&id=5ce9b6c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce9b6c4",
  null
  
)

export default component.exports